export const myPgaIOSUrl =
  'https://apps.apple.com/us/app/pga-coach/id1448721089'
export const myPgaAndroidUrl =
  'https://play.google.com/store/apps/details?id=com.pga.pgacoach&amp;hl=en_US'
